const GROSS_REVENUE = 'Gross Revenue',
GROSS_REVENUE_KEY = 'total_revenue',
GROSS_REVENUE_TARGET = 'Gross Revenue Target',
GROSS_REVENUE_TARGET_KEY = 'total_revenue_target',
GROSS_REVENUE_COMPLETION = 'Gross Revenue Completion',
GROSS_REVENUE_COMPLETION_KEY = '',
GROSS_REVENUE_YTM = 'Gross Revenue YTM',
GROSS_REVENUE_YTM_KEY = 'ytm_total_revenue',
GROSS_REVENUE_TARGET_YTM = 'Gross Revenue Target YTM',
GROSS_REVENUE_TARGET_YTM_KEY = 'ytm_total_revenue_target',
GROSS_REVENUE_YTM_COMPLETION = 'Gross Revenue YTM Completion',
GROSS_REVENUE_YTM_COMPLETION_KEY = '',
NET_PROFIT = 'Net Profit',
NET_PROFIT_KEY = '',
NET_PROFIT_TARGET = 'Net Profit Target',
NET_PROFIT_TARGET_KEY = '',
NET_PROFIT_COMPLETION = 'Net Profit Completion',
NET_PROFIT_COMPLETION_KEY = '',
NET_PROFIT_YTM = 'Net Profit YTM',
NET_PROFIT_YTM_KEY = '',
NET_PROFIT_TARGET_YTM = 'Net Profit Target YTM',
NET_PROFIT_TARGET_YTM_KEY = '',
NET_PROFIT_YTM_COMPLETION = 'Net Profit YTM Completion',
NET_PROFIT_YTM_COMPLETION_KEY = '',
MAU = 'MAU',
MAU_KEY = 'total_mau';

// 接口返回字段前端使用映射表
const RES_FIELDS_MAP: any = {
  [GROSS_REVENUE]: {
    key: GROSS_REVENUE_KEY,
    'yoy': false,
    'mom': true,
  },
  [GROSS_REVENUE_TARGET]: {
    key: [GROSS_REVENUE_TARGET_KEY],
    'yoy': false,
    'mom': true,
  },
  [GROSS_REVENUE_COMPLETION]: {
    key: GROSS_REVENUE_COMPLETION_KEY,
  },
  [GROSS_REVENUE_YTM]: {
    key: GROSS_REVENUE_YTM_KEY,
    'yoy': true,
    'mom': false,
  },
  [GROSS_REVENUE_TARGET_YTM]: {
    key: GROSS_REVENUE_TARGET_YTM_KEY,
    'yoy': true,
    'mom': false,
  },
  [GROSS_REVENUE_YTM_COMPLETION]: {
    key: GROSS_REVENUE_YTM_COMPLETION_KEY,
  },
  [NET_PROFIT]: {
    key: NET_PROFIT_KEY,
    'yoy': true,
    'mom': true,
  },
  [NET_PROFIT_TARGET]: {
    key: NET_PROFIT_TARGET_KEY,
  },
  [NET_PROFIT_COMPLETION]: {
    key: NET_PROFIT_COMPLETION_KEY,
  },
  [NET_PROFIT_YTM]: {
    key: [NET_PROFIT_YTM_KEY],
    'yoy': true,
    'mom': true,
  },
  [NET_PROFIT_TARGET_YTM]: {
    key: NET_PROFIT_TARGET_YTM_KEY,
  },
  [NET_PROFIT_YTM_COMPLETION]: {
    key: NET_PROFIT_YTM_COMPLETION_KEY,
  },
  [MAU]: {
    key: MAU_KEY,
    'yoy': false,
    'mom': true,
  }
};

// 排序传参字段映射表
const SORT_REQ_MAP: any = {
  'studio': 'studio',
  'projects': 'game_name',
  'bo': 'bo',
  'genre': 'genre',
  [GROSS_REVENUE_KEY]: GROSS_REVENUE,
  [GROSS_REVENUE_TARGET_KEY]: GROSS_REVENUE_TARGET,
  [GROSS_REVENUE_YTM_KEY]: GROSS_REVENUE_YTM,
  [GROSS_REVENUE_TARGET_YTM_KEY]: GROSS_REVENUE_TARGET_YTM,
  [MAU_KEY]: MAU,
};

export {
  RES_FIELDS_MAP,
  SORT_REQ_MAP,
}
